import { Cancel } from '@material-ui/icons'
import {
  Create,
  CreateProps,
  TextInput,
  useTranslate,
  BooleanInput,
  SimpleForm,
  Toolbar,
  ToolbarProps,
  SaveButton,
  ListButton,
} from 'react-admin'
import React from 'react'
import { VariantDto } from '../../../core/dto/variant.dto'

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

const validateVariantCreate = (values: VariantDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.name) {
    errors.name = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.variants.titles.create')}</span>
}

export const VariantCreate = (props: CreateProps) => (
  <Create {...props} title={<CreateTitle />}>
    <SimpleForm
      redirect="show"
      validate={validateVariantCreate}
      toolbar={<CreateToolbar />}
    >
      <TextInput source="name" isRequired />
      <BooleanInput source="active" />
    </SimpleForm>
  </Create>
)
